/**
 * Atelier Mino — page « Notre histoire » (section mino-histoire, 14/10/2026).
 * - Apparition : chaque [data-mino-etape] apparaît dès que son haut passe au-dessus de 90 % de l'écran (une seule fois).
 * - Chronologie : la ligne se trace au fil du défilement ; --mino-hist-progres (0 à 1) suit le milieu de l'écran dans la
 *   frise, le point laser est posé à la tête de la ligne ; une étape dont le point est dépassé reçoit is-atteinte.
 * Le défilement peut se faire sur la fenêtre ou dans un conteneur du thème : on écoute le scroll en capture sur le document
 * et on mesure avec getBoundingClientRect. Mouvement réduit ou navigateur ancien : tout est visible, ligne pleine.
 */
(() => {
  const racines = document.querySelectorAll('.mino-hist');
  if (!racines.length) return;
  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduit || !window.requestAnimationFrame) return;

  racines.forEach((racine) => {
    racine.classList.add('is-anime');
    // apparition : mesurée à chaque défilement (pas d'IntersectionObserver seul : un défilement rapide ou un saut par
    // ancre laisserait invisibles les éléments déjà dépassés)
    let restants = [...racine.querySelectorAll('[data-mino-etape]')];
    const reveler = () => {
      const bas = window.innerHeight * 0.9;
      restants = restants.filter((el) => {
        if (el.getBoundingClientRect().top < bas) { el.classList.add('is-visible'); return false; }
        return true;
      });
    };

    const frise = racine.querySelector('.mino-hist__frise');
    const etapes = frise ? [...frise.querySelectorAll('.mino-hist__etape')] : [];
    let prevu = false;
    const mesurer = () => {
      prevu = false;
      reveler();
      if (!frise) return;
      const r = frise.getBoundingClientRect();
      const repere = window.innerHeight * 0.55;
      const p = Math.min(1, Math.max(0, (repere - r.top) / Math.max(1, r.height)));
      racine.style.setProperty('--mino-hist-progres', p.toFixed(4));
      const tete = r.top + p * r.height;
      etapes.forEach((et) => {
        const point = et.querySelector('.mino-hist__point');
        if (point) et.classList.toggle('is-atteinte', point.getBoundingClientRect().top + 11 <= tete);
      });
    };
    const demander = () => { if (!prevu) { prevu = true; requestAnimationFrame(mesurer); } };
    document.addEventListener('scroll', demander, { passive: true, capture: true });
    window.addEventListener('resize', demander, { passive: true });
    mesurer();
  });
})();
